import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import HomeIcon from '@mui/icons-material/Home';
import { AppBreadcrumb, Crumb } from '../../components/navigation';

const muiItems: Crumb[] = [
  { label: 'Início', href: '/', icon: <HomeIcon fontSize="small" /> },
  { label: 'Torneios', href: '/torneios' },
  { label: 'Open de Manaus', href: '/torneios/123' },
  { label: 'Inscrições' },
];

const bootstrapItems: Crumb[] = [
  { label: 'Dashboard', href: '/admin', icon: <i className="bi bi-house" aria-hidden="true" /> },
  { label: 'Gestão', href: '/admin/gestao' },
  { label: 'Atletas', href: '/admin/atletas' },
  { label: 'Edição', onClick: () => undefined },
];

const BreadcrumbDemoPage: React.FC = () => (
  <Container className="py-4">
    <Row>
      <Col md={6} className="mb-4">
        <Card>
          <Card.Body>
            <Card.Title>Material-UI variant</Card.Title>
            <div className="d-flex flex-column gap-3 mt-3">
              <AppBreadcrumb items={muiItems} variant="mui" />
              <AppBreadcrumb items={muiItems} variant="mui" maxItems={3} />
              <AppBreadcrumb items={muiItems} variant="mui" separator=">" />
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col md={6} className="mb-4">
        <Card>
          <Card.Body>
            <Card.Title>React-Bootstrap variant</Card.Title>
            <div className="d-flex flex-column gap-3 mt-3">
              <AppBreadcrumb items={bootstrapItems} variant="bootstrap" />
              <AppBreadcrumb items={bootstrapItems} variant="bootstrap" maxItems={3} />
              <AppBreadcrumb items={bootstrapItems} variant="bootstrap" separator=">" />
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
);

export default BreadcrumbDemoPage;
